module.exports = __webpack_public_path__ + "static/media/enchilada-cabreras.e578ac82.jpg";